import { Button, IconButton, keyframes, Stack, Typography } from '@mui/material';
import {
  ArrowRightIcon,
  CrossIcon,
  ModalConfirm,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@schooly/style';
import { FC, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router';

export const DemoSchoolCreatedModal: FC = () => {
  const navigate = useNavigate();
  const { $t } = useIntl();
  const handleClose = useCallback(() => {
    navigate('/students');
  }, [navigate]);

  return (
    <ModalConfirm
      open
      onClose={handleClose}
      PaperProps={{ sx: { animation: `${fadeIn} .35s ease` } }}
    >
      <ModalHeader
        active
        multiline
        title={
          <Typography variant="h1" color="primary.main">
            {$t({ id: 'school-demo-Welcome' })}
          </Typography>
        }
        withBorderBottom={false}
      >
        <IconButton onClick={handleClose}>
          <CrossIcon />
        </IconButton>
      </ModalHeader>
      <ModalContent active>
        <Stack alignItems="center">
          <SuccessImageSvg />
        </Stack>
        <Typography variant="h2" my={3}>
          {$t({ id: 'school-demo-TryNoRestrictions' })}
        </Typography>
        <Typography variant="h2">{$t({ id: 'school-demo-NoteSchoolLive' })}</Typography>
      </ModalContent>
      <ModalFooter active>
        <Button endIcon={<ArrowRightIcon />} onClick={handleClose}>
          {$t({ id: 'action-Start' })}
        </Button>
      </ModalFooter>
    </ModalConfirm>
  );
};

const fadeIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.65);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

const SuccessImageSvg: FC = () => {
  return (
    <svg
      width="300"
      height="300"
      viewBox="0 0 300 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M116.885 155H115.464V144.336H116.885V155ZM120.723 155H119.354V143.75H120.723V155ZM124.371 155H123.001V143.75H124.371V155ZM131.38 147.075H132.75V155H131.446L131.38 153.169V147.075ZM132.208 151.484C132.208 152.188 132.107 152.815 131.907 153.367C131.707 153.918 131.38 154.353 130.926 154.67C130.472 154.988 129.864 155.146 129.102 155.146C128.326 155.146 127.698 154.917 127.22 154.458C126.741 153.999 126.502 153.242 126.502 152.188V147.075H127.872V152.202C127.872 152.681 127.94 153.052 128.077 153.315C128.218 153.574 128.399 153.755 128.619 153.857C128.843 153.955 129.078 154.004 129.322 154.004C129.898 154.004 130.354 153.894 130.691 153.674C131.028 153.45 131.27 153.147 131.417 152.766C131.563 152.385 131.636 151.963 131.636 151.499L132.208 151.484ZM139.422 152.898C139.422 152.703 139.378 152.522 139.29 152.356C139.207 152.185 139.036 152.031 138.777 151.895C138.519 151.753 138.128 151.628 137.605 151.521C137.02 151.399 136.512 151.245 136.082 151.06C135.657 150.869 135.328 150.627 135.093 150.334C134.864 150.042 134.749 149.678 134.749 149.243C134.749 148.823 134.869 148.44 135.108 148.093C135.352 147.742 135.694 147.461 136.133 147.251C136.578 147.036 137.095 146.929 137.686 146.929C138.321 146.929 138.863 147.041 139.312 147.266C139.766 147.485 140.113 147.783 140.352 148.159C140.591 148.53 140.711 148.943 140.711 149.397H139.341C139.341 149.07 139.197 148.76 138.909 148.467C138.626 148.174 138.218 148.027 137.686 148.027C137.315 148.027 137.012 148.086 136.778 148.203C136.548 148.315 136.38 148.462 136.272 148.643C136.17 148.818 136.119 149.004 136.119 149.199C136.119 149.395 136.167 149.565 136.265 149.712C136.363 149.854 136.541 149.98 136.8 150.093C137.063 150.205 137.444 150.317 137.942 150.43C138.592 150.576 139.126 150.752 139.546 150.957C139.966 151.162 140.279 151.414 140.484 151.711C140.689 152.009 140.792 152.373 140.792 152.803C140.792 153.262 140.665 153.669 140.411 154.026C140.157 154.377 139.8 154.653 139.341 154.854C138.882 155.049 138.343 155.146 137.723 155.146C137.024 155.146 136.434 155.022 135.95 154.773C135.467 154.524 135.101 154.204 134.852 153.813C134.603 153.418 134.478 153 134.478 152.561H135.848C135.872 152.932 135.979 153.228 136.17 153.447C136.365 153.662 136.602 153.816 136.88 153.909C137.164 154.001 137.444 154.048 137.723 154.048C138.094 154.048 138.404 153.999 138.653 153.901C138.907 153.799 139.097 153.662 139.224 153.491C139.356 153.315 139.422 153.118 139.422 152.898ZM145.889 148.108H141.597V147.075H145.889V148.108ZM144.41 145.149V153.037C144.41 153.311 144.451 153.516 144.534 153.652C144.617 153.789 144.725 153.879 144.856 153.923C144.988 153.967 145.13 153.989 145.281 153.989C145.394 153.989 145.511 153.979 145.633 153.96C145.76 153.94 145.853 153.923 145.911 153.909L145.918 155C145.811 155.034 145.669 155.066 145.494 155.095C145.323 155.129 145.115 155.146 144.871 155.146C144.539 155.146 144.234 155.081 143.956 154.949C143.677 154.817 143.455 154.597 143.289 154.29C143.123 153.977 143.04 153.557 143.04 153.03V145.149H144.41ZM148.833 155H147.464V147.075H148.797L148.833 148.32V155ZM151.302 148.284C151.185 148.259 151.075 148.245 150.972 148.24C150.875 148.23 150.762 148.225 150.635 148.225C150.22 148.225 149.869 148.311 149.581 148.481C149.297 148.652 149.078 148.889 148.921 149.192C148.765 149.49 148.667 149.832 148.628 150.217L148.24 150.437C148.24 149.797 148.326 149.214 148.497 148.687C148.667 148.154 148.934 147.729 149.295 147.412C149.661 147.09 150.13 146.929 150.701 146.929C150.794 146.929 150.904 146.941 151.031 146.965C151.163 146.985 151.253 147.007 151.302 147.031V148.284ZM156.985 149.565C156.985 149.092 156.844 148.716 156.561 148.438C156.282 148.154 155.87 148.013 155.323 148.013C154.986 148.013 154.688 148.071 154.429 148.188C154.175 148.306 153.978 148.459 153.836 148.65C153.694 148.84 153.624 149.048 153.624 149.272H152.254C152.254 148.892 152.383 148.523 152.642 148.167C152.901 147.805 153.265 147.51 153.733 147.28C154.207 147.046 154.764 146.929 155.403 146.929C155.979 146.929 156.49 147.026 156.934 147.222C157.378 147.417 157.725 147.712 157.974 148.108C158.228 148.499 158.355 148.989 158.355 149.58V153.271C158.355 153.535 158.377 153.816 158.421 154.114C158.47 154.412 158.541 154.668 158.633 154.883V155H157.205C157.137 154.844 157.083 154.636 157.044 154.377C157.005 154.114 156.985 153.87 156.985 153.645V149.565ZM157.234 151.147H155.872C155.101 151.147 154.505 151.27 154.085 151.514C153.665 151.758 153.455 152.124 153.455 152.612C153.455 152.993 153.582 153.315 153.836 153.579C154.095 153.843 154.471 153.975 154.964 153.975C155.379 153.975 155.745 153.887 156.062 153.711C156.38 153.535 156.631 153.318 156.817 153.059C157.002 152.8 157.103 152.551 157.117 152.312L157.703 152.964C157.669 153.169 157.576 153.396 157.425 153.645C157.273 153.894 157.071 154.133 156.817 154.363C156.568 154.587 156.27 154.775 155.923 154.927C155.582 155.073 155.196 155.146 154.766 155.146C154.229 155.146 153.758 155.044 153.353 154.839C152.952 154.629 152.64 154.346 152.415 153.989C152.195 153.633 152.085 153.237 152.085 152.803C152.085 151.948 152.408 151.301 153.052 150.862C153.697 150.417 154.563 150.195 155.652 150.195H157.22L157.234 151.147ZM163.819 148.108H159.527V147.075H163.819V148.108ZM162.339 145.149V153.037C162.339 153.311 162.381 153.516 162.464 153.652C162.547 153.789 162.654 153.879 162.786 153.923C162.918 153.967 163.06 153.989 163.211 153.989C163.323 153.989 163.44 153.979 163.562 153.96C163.689 153.94 163.782 153.923 163.841 153.909L163.848 155C163.741 155.034 163.599 155.066 163.423 155.095C163.252 155.129 163.045 155.146 162.801 155.146C162.469 155.146 162.164 155.081 161.885 154.949C161.607 154.817 161.385 154.597 161.219 154.29C161.053 153.977 160.97 153.557 160.97 153.03V145.149H162.339ZM166.88 155H165.511V147.075H166.88V155ZM165.408 144.966C165.408 144.751 165.474 144.568 165.606 144.417C165.743 144.265 165.943 144.189 166.207 144.189C166.47 144.189 166.67 144.265 166.807 144.417C166.949 144.568 167.02 144.751 167.02 144.966C167.02 145.176 166.949 145.356 166.807 145.508C166.67 145.654 166.47 145.728 166.207 145.728C165.943 145.728 165.743 145.654 165.606 145.508C165.474 145.356 165.408 145.176 165.408 144.966ZM168.689 150.957C168.689 150.19 168.836 149.504 169.129 148.899C169.422 148.293 169.837 147.815 170.374 147.463C170.911 147.107 171.548 146.929 172.286 146.929C173.033 146.929 173.677 147.107 174.219 147.463C174.761 147.815 175.176 148.293 175.464 148.899C175.757 149.504 175.904 150.19 175.904 150.957V151.125C175.904 151.887 175.757 152.573 175.464 153.184C175.176 153.789 174.761 154.268 174.219 154.619C173.682 154.971 173.042 155.146 172.3 155.146C171.558 155.146 170.916 154.971 170.374 154.619C169.837 154.268 169.422 153.789 169.129 153.184C168.836 152.573 168.689 151.887 168.689 151.125V150.957ZM170.059 151.125C170.059 151.648 170.142 152.131 170.308 152.576C170.474 153.02 170.721 153.376 171.048 153.645C171.38 153.914 171.797 154.048 172.3 154.048C172.798 154.048 173.211 153.914 173.538 153.645C173.87 153.376 174.119 153.02 174.285 152.576C174.451 152.131 174.534 151.648 174.534 151.125V150.957C174.534 150.435 174.451 149.951 174.285 149.507C174.119 149.062 173.87 148.706 173.538 148.438C173.206 148.164 172.789 148.027 172.286 148.027C171.792 148.027 171.38 148.164 171.048 148.438C170.716 148.706 170.467 149.062 170.301 149.507C170.14 149.951 170.059 150.435 170.059 150.957V151.125ZM178.98 155H177.61V147.075H178.907L178.98 148.767V155ZM178.086 150.708C178.096 149.985 178.235 149.341 178.504 148.774C178.772 148.203 179.146 147.754 179.625 147.427C180.108 147.095 180.669 146.929 181.309 146.929C181.832 146.929 182.281 147.026 182.657 147.222C183.038 147.412 183.331 147.717 183.536 148.137C183.746 148.557 183.851 149.114 183.851 149.807V155H182.481V149.792C182.481 149.377 182.42 149.043 182.298 148.789C182.181 148.535 182.005 148.352 181.771 148.24C181.536 148.123 181.248 148.064 180.906 148.064C180.569 148.064 180.264 148.135 179.991 148.276C179.717 148.418 179.48 148.613 179.28 148.862C179.08 149.111 178.926 149.397 178.819 149.719C178.711 150.037 178.658 150.374 178.658 150.73L178.086 150.708Z"
        fill="#B3BBCB"
      />
      <path
        d="M195.463 239.13L165.483 260.48L116.253 241.29L146.313 220.7L195.463 239.13Z"
        fill="#27245C"
        stroke="#C7C8DD"
        strokeLinejoin="round"
      />
      <path
        d="M185.153 196.38L165.163 260.48L116.253 240.86L136.283 168.16L185.153 196.37V196.38Z"
        fill="#C7C8DD"
        stroke="#C7C8DD"
        strokeLinejoin="round"
      />
      <path
        d="M163.513 72.7399L163.163 72.5999V72.5699L79.5129 39.2799C72.4029 36.4499 64.6729 41.6899 64.6729 49.3499V178.29L163.933 217.79L262.783 257.13V124.91C262.783 117.26 258.123 110.39 251.013 107.56L163.523 72.7399H163.513Z"
        fill="#F7F8FC"
        stroke="#C7C8DD"
        strokeLinejoin="round"
      />
      <path
        d="M174.268 64.9902V65.0202L174.618 65.1602H174.628L262.118 99.9802C269.228 102.81 273.888 109.68 273.888 117.33V139.55"
        stroke="#24275B"
        strokeLinejoin="round"
      />
      <path
        d="M163.543 84.2401L163.223 84.1101V84.0801L88.9031 54.5101C82.5831 52.0001 75.7231 56.6501 75.7231 63.4501V171.75L163.903 206.84L251.713 241.79V130.58C251.713 123.79 247.573 117.68 241.253 115.16L163.523 84.2301L163.543 84.2401Z"
        fill="white"
        stroke="#C7C8DD"
        strokeMiterlimit="10"
      />
      <path
        d="M89.7258 98.2483C81.5228 89.0833 80.7888 76.3586 88.0864 69.8269C95.3841 63.2952 107.95 65.4299 116.153 74.5948C124.356 83.7598 125.09 96.4845 117.792 103.016C110.495 109.548 97.9289 107.413 89.7258 98.2483Z"
        fill="#27245C"
      />
      <path
        d="M110.873 91.8977L92.7563 84.2261C92.2772 84.0231 91.8939 84.2486 91.8939 84.7221V89.8966C91.8939 90.3758 92.2829 90.9225 92.7563 91.1255L110.873 98.7971C111.352 99 111.735 98.7746 111.735 98.3011V93.1265C111.735 92.6474 111.346 92.1006 110.873 91.8977Z"
        fill="white"
        stroke="#252858"
      />
      <path
        d="M108.286 85.0605L95.3436 79.5815V92.2248L108.286 97.7038V85.0605Z"
        fill="white"
        stroke="#252858"
      />
      <path
        d="M103.974 89.835C103.974 89.3559 103.585 88.8091 103.111 88.6062L100.524 87.5127C100.045 87.3098 99.6615 87.5352 99.6615 88.0087V94.0457L103.974 95.872V89.835Z"
        fill="white"
        stroke="#252858"
      />
      <path
        d="M95.9469 80.3988L94.3405 79.7168C93.4498 79.3391 93.1455 78.0314 93.9177 77.9243L101.815 76.8477L109.712 84.6151C110.49 85.3761 110.18 86.4302 109.289 86.0525L108.004 85.5057"
        fill="white"
      />
      <path
        d="M95.9469 80.3988L94.3405 79.7168C93.4498 79.3391 93.1455 78.0314 93.9177 77.9243L101.815 76.8477L109.712 84.6151C110.49 85.3761 110.18 86.4302 109.289 86.0525L108.004 85.5057"
        stroke="#252858"
      />
      <path
        d="M100.952 82.518C100.952 82.9971 101.341 83.5439 101.814 83.7468C102.288 83.9497 102.677 83.7243 102.677 83.2508C102.677 82.7773 102.288 82.2249 101.814 82.022C101.341 81.819 100.952 82.0445 100.952 82.518Z"
        fill="white"
      />
      <path
        d="M100.724 83.7606C99.9828 82.8464 99.8685 81.7112 100.468 81.2251C101.068 80.739 102.155 81.0861 102.896 82.0004C103.637 82.9146 103.751 84.0498 103.151 84.5359C102.551 85.022 101.465 84.6749 100.724 83.7606Z"
        fill="white"
        stroke="#252858"
      />
      <path
        d="M107.523 123.024C112.71 128.82 113.157 136.566 108.904 140.373C104.652 144.179 97.0018 142.88 91.8146 137.084C86.6275 131.289 86.1804 123.542 90.4333 119.736C94.6862 115.929 102.336 117.229 107.523 123.024Z"
        fill="#FFFEF8"
        stroke="#24275B"
      />
      <path
        d="M105.515 124.821C109.413 129.176 109.713 134.95 106.569 137.764C103.425 140.578 97.7197 139.642 93.8222 135.287C89.9248 130.933 89.6243 125.159 92.7684 122.345C95.9125 119.531 101.618 120.467 105.515 124.821Z"
        fill="#FFFEF8"
        stroke="#24275B"
      />
      <path
        d="M107.523 155.024C112.71 160.82 113.157 168.566 108.904 172.373C104.652 176.179 97.0018 174.88 91.8146 169.084C86.6275 163.289 86.1804 155.542 90.4333 151.736C94.6862 147.929 102.336 149.229 107.523 155.024Z"
        fill="#FFFEF8"
        stroke="#24275B"
      />
      <path
        d="M93.0596 125.176L99.0596 133.029L117.06 119.029"
        stroke="#252858"
        strokeLinecap="round"
      />
      <path
        d="M3 192C3 192 27.373 165 65.373 146C101.083 131.139 57.9204 170.751 57.9204 170.751C57.9204 170.751 90.1727 179.189 87.5422 201.216C85.5773 217.694 75.9534 223.425 75.9534 223.425"
        fill="white"
      />
      <path
        d="M3 192C3 192 27.373 165 65.373 146C101.083 131.139 57.9204 170.751 57.9204 170.751C57.9204 170.751 90.1727 179.189 87.5422 201.216C85.5773 217.694 75.9534 223.425 75.9534 223.425"
        stroke="#252858"
        strokeMiterlimit="10"
      />
      <path d="M67.873 207.5C66.373 216 59.573 235.1 44.373 243.5" stroke="#24275B" />
      <path
        d="M60.8953 171.68C60.8953 171.68 49.6762 163.288 28.8613 183.59L60.8953 171.68Z"
        fill="white"
      />
      <path
        d="M60.8953 171.68C60.8953 171.68 49.6762 163.288 28.8613 183.59"
        stroke="#252858"
        strokeMiterlimit="10"
      />
      <path
        d="M72.2236 176.832C72.2236 176.832 62.7969 168.89 41.9785 189.192L72.2236 176.832Z"
        fill="white"
      />
      <path
        d="M72.2236 176.832C72.2236 176.832 62.7969 168.89 41.9785 189.192"
        stroke="#252858"
        strokeMiterlimit="10"
      />
      <path
        d="M83.9393 187.044C83.9393 187.044 73.2061 178.456 52.3877 198.761L83.9393 187.044Z"
        fill="white"
      />
      <path
        d="M83.9393 187.044C83.9393 187.044 73.2061 178.456 52.3877 198.761"
        stroke="#252858"
        strokeMiterlimit="10"
      />
      <path
        d="M67.1954 220.967C67.0616 222.668 70.3224 227.058 75.9566 223.429L67.1954 220.967Z"
        fill="white"
      />
      <path
        d="M75.9566 223.429C70.3224 227.058 67.0616 222.668 67.1954 220.967C67.1954 217.5 69.373 211.1 71.373 207.5"
        stroke="#252858"
        strokeMiterlimit="10"
      />
      <path
        d="M73.0459 100.995L83.9867 117.838"
        stroke="#252858"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M41.9009 115.7L82.3919 125.785"
        stroke="#252858"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M228.823 140.55L228.483 140.42V140.39L148.973 108.75C142.213 106.06 134.873 111.04 134.873 118.32V154.74C134.873 161.36 138.913 167.32 145.063 169.77L229.213 203.26L279.133 223.16C285.963 225.88 293.373 220.85 293.373 213.5V178.32C293.373 171.05 288.943 164.52 282.183 161.83L228.813 140.56L228.823 140.55Z"
        fill="#F7F8FC"
      />
      <path
        d="M216.727 152.905C216.727 152.905 180.588 151.782 187.659 144.688C192.223 140.082 199.244 140.828 201.732 142.093C204.22 143.358 198.058 149.268 179.275 142.767C160.502 136.264 181.877 131.282 184.26 133.077C186.642 134.862 180.725 142.525 158.873 131.812"
        stroke="#252858"
        strokeMiterlimit="10"
      />
      <path
        d="M222.143 177.911C222.143 177.911 196.478 177.925 194.277 174.734C192.067 171.607 203.203 173.349 201.756 170.226C200.319 167.101 179.43 168.977 176.705 165.13C173.969 161.284 186.218 163.902 181.047 160.303C175.876 156.703 160.333 157.34 155.873 152.779"
        stroke="#252858"
        strokeMiterlimit="10"
      />
      <path
        d="M279.133 225.65L144.333 171.62C137.373 168.85 132.873 162.22 132.873 154.73V118.31C132.873 111.52 138.383 106 145.163 106C146.713 106 148.253 106.3 149.723 106.88L230.493 139.02V139.05L283.663 160.59C291.223 163.6 296.113 170.8 296.113 178.94V214.12C296.113 217.5 294.783 220.65 292.373 223C290.063 225.24 286.913 226.53 283.723 226.53"
        stroke="#27245C"
        strokeMiterlimit="10"
      />
    </svg>
  );
};
